import { html } from 'lit';
const Apple =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M15.084 4.424c-.72.87-1.923 1.514-2.879 1.514-.118 0-.226-.021-.29-.032-.01-.053-.043-.215-.043-.386 0-1.096.559-2.192 1.171-2.88.763-.902 2.052-1.568 3.126-1.61.021.117.032.268.032.418 0 1.096-.462 2.18-1.117 2.976m.752 1.74c.601 0 2.782.065 4.21 2.116-.128.097-2.287 1.322-2.287 4.05 0 3.147 2.75 4.275 2.836 4.297-.011.075-.44 1.525-1.45 3.018-.914 1.3-1.87 2.622-3.31 2.622-1.45 0-1.825-.849-3.48-.849-1.632 0-2.212.849-3.523.849-1.332 0-2.256-1.193-3.309-2.675C4.288 17.84 3.3 15.123 3.3 12.545c0-4.125 2.685-6.38 5.339-6.38 1.396 0 2.556.977 3.448.977.838 0 2.148-.978 3.749-.978"/>
  </svg>
`;
export default Apple;
